import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { ArrowUpRight } from "lucide-react";

const CourseCard = ({ c }) => (
  <Link to={`/courses/${c.slug}`} data-testid={`course-card-${c.slug}`}
    className="group grid grid-cols-3 border border-black/10 bg-white hover:-translate-y-1 hover:shadow-lg transition-[transform,box-shadow] duration-300">
    <div className="col-span-1 overflow-hidden border-r border-black/10">
      <img src={c.image} alt={c.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
    </div>
    <div className="col-span-2 p-7">
      <div className="flex justify-between items-start">
        <p className="label text-gold">{c.level} · {c.hsk}</p>
        <ArrowUpRight className="text-clay group-hover:text-cinnabar transition-colors" size={18} />
      </div>
      <h3 className="text-2xl mt-3 group-hover:text-cinnabar transition-colors">{c.title}</h3>
      <p className="text-sm text-clay mt-3 leading-relaxed">{c.tagline}</p>
      <div className="mt-6 flex items-center justify-between">
        <span className="font-display font-bold text-ink text-lg">₹{c.price_inr.toLocaleString("en-IN")}</span>
        <span className="text-xs text-clay font-mono">{c.duration}{c.hours ? ` · ${c.hours}` : ""}</span>
      </div>
    </div>
  </Link>
);

export default function Courses() {
  const [language, setLanguage] = useState([]);
  const [hskPrep, setHskPrep] = useState([]);

  useEffect(() => {
    api.get("/courses", { params: { category: "language" } }).then((r) => setLanguage(r.data)).catch(() => {});
    api.get("/courses", { params: { category: "hsk_prep" } }).then((r) => setHskPrep(r.data)).catch(() => {});
  }, []);

  return (
    <div className="max-w-7xl mx-auto px-6 lg:px-10 py-16">
      <span className="label text-cinnabar">Mandarin Chinese · HSK 3.0</span>
      <h1 className="font-serif font-light text-5xl sm:text-6xl tracking-tighter mt-4 mb-4">Language Courses</h1>
      <p className="text-clay max-w-2xl mb-14 text-lg">Progress step by step from absolute beginner to advanced mastery, each level aligned to the new HSK 3.0 standard.</p>

      <div className="grid md:grid-cols-2 gap-8">
        {language.map((c) => <CourseCard key={c.course_id} c={c} />)}
      </div>

      <div className="mt-24">
        <span className="label text-cinnabar">HSK 2.0 Exam Preparation · Levels 3–6</span>
        <h2 className="font-serif text-4xl sm:text-5xl tracking-tight mt-3 mb-4">HSK Exam Preparation</h2>
        <p className="text-clay max-w-2xl mb-12 text-lg">Focused, exam-oriented courses to clear each HSK level — from 600 words at HSK 3 to 5000+ at HSK 6, with full mock tests.</p>
        <div className="grid md:grid-cols-2 gap-8">
          {hskPrep.map((c) => <CourseCard key={c.course_id} c={c} />)}
        </div>
      </div>
    </div>
  );
}
